var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgChatNav = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.16634 2.5C3.24587 2.5 2.49967 3.24619 2.49967 4.16667V17.155L5.24377 14.9597C5.39154 14.8415 5.57513 14.7771 5.76437 14.7771H15.833C16.7535 14.7771 17.4997 14.0309 17.4997 13.1104V4.16667C17.4997 3.24619 16.7535 2.5 15.833 2.5H4.16634ZM0.833008 4.16667C0.833008 2.32572 2.32539 0.833336 4.16634 0.833336H15.833C17.674 0.833336 19.1663 2.32572 19.1663 4.16667V13.1104C19.1663 14.9513 17.674 16.4437 15.833 16.4437H6.05668L2.18712 19.5394C1.93698 19.7395 1.59431 19.7786 1.30566 19.6399C1.01702 19.5011 0.833008 19.2092 0.833008 18.8889V4.16667ZM5.83301 6.66667C5.83301 6.20643 6.2061 5.83334 6.66634 5.83334H13.333C13.7932 5.83334 14.1663 6.20643 14.1663 6.66667C14.1663 7.12691 13.7932 7.5 13.333 7.5H6.66634C6.2061 7.5 5.83301 7.12691 5.83301 6.66667ZM6.66634 9.16667C6.2061 9.16667 5.83301 9.53977 5.83301 10C5.83301 10.4602 6.2061 10.8333 6.66634 10.8333H10.833C11.2932 10.8333 11.6663 10.4602 11.6663 10C11.6663 9.53977 11.2932 9.16667 10.833 9.16667H6.66634Z",
    fill: "currentColor"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgChatNav, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/chat-nav.bb9d0702.svg";
export { ForwardRef as ReactComponent };